import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { PROPOSAL_KEYS } from "~/api/cache"

import type { PowurOsPricingDto } from "../dto/proposal.dto"
import { ProposalService } from "../services/proposal.service"

const proposalService = new ProposalService()

function useUpdateProposalMargin(): UseMutationResult<
  PowurOsPricingDto,
  unknown,
  {
    id: string
    margin: number
  }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, margin }): Promise<PowurOsPricingDto> => {
      return proposalService.fetchTotalCostByMargin(id, margin)
    },
    onSuccess: (data, variables) => {
      // Update the cache with the server response
      queryClient.setQueryData<PowurOsPricingDto>(
        PROPOSAL_KEYS.pricing(variables.id),
        data,
      )

      return { data }
    },
  })
}

export default useUpdateProposalMargin
